import React, { useContext } from 'react'
import { DemoContext } from '../lib/DemoProvider'
import Button from '@react/react-spectrum/Button'
import Well from '@react/react-spectrum/Well'

import SyntaxHighlighter from 'react-syntax-highlighter'
import { atomOneDark } from 'react-syntax-highlighter/dist/esm/styles/hljs'
import analytics from '../config/analytics'

export default function Integrationhtml () {
    const { isMobile, page } = useContext(DemoContext)
    const language = 'html'
    const style = atomOneDark
    const lineNumberStyle = { color: 'rgba(112, 112, 112, 0.8)' }
    const showLineNumbers = true
    const assetUrl = `${process.env.REACT_APP_DISDK_PROD_URL}/demo/remove-background/html/asset`
    let text = ''

    
    text += '<!DOCTYPE html>\n'
    text += '<html lang="en">\n'
    text += '\t<head>\n'
    text += `\t\t<script src="${process.env.REACT_APP_DISDK_PROD_URL}/cdn/remove-background/lib/remove-background.js"></script>\n`
    text += '\t\t<meta charset="utf-8">\n'
    text += '\t\t<title>Photoshop API SDK Remove Background Editor</title>\n'
    text += '\t</head>\n'
    text += '\t<body style="background-color:darkgray;">\n'
    text += '\t\t<div style="display:table-caption; width: 400px;">\n'
    text += '\t\t\t<remove-background\n'
    text += `\t\t\t\timage-data="${assetUrl}/antique001.jpg"\n`
    text += `\t\t\t\tcutout-data="${assetUrl}/antique001.png">\n`
    text += '\t\t\t</remove-background>\n'
    text += `\t\t\t<button onclick="editCutout('${assetUrl}/antique001.jpg')">Edit</button>\n`
    text += `\t\t\t<button onclick="saveCutout('${assetUrl}/antique001.jpg', 'antique001.png')">Save</button>\n`
    text += `\t\t\t<button onclick="downloadCutout('${assetUrl}/antique001.jpg', 'antique001.png')">Download</button>\n`
    text += '\t\t</div>\n'
    text += '\t\t<div>\n'
    text += '\t\t\t<hr />\n'
    text += '\t\t\t<p>Copyright © 2023 Adobe. All rights reserved.</p>\n'
    text += '\t\t</div>\n'
    text += '\t\t<script>\n'
    text += '\t\t\t//sample 1\n'
    text += '\t\t\twindow.addEventListener("refineCutoutDoneEvent", (e) => {\n'
    text += '\t\t\t\ttry {\n'
    text += '\t\t\t\t\t// TODO - save edited image (e.detail.cutout) to your storage\n'
    text += '\t\t\t\t\t// Edited image\n'
    text += '\t\t\t\t\tconsole.log(e.detail.cutout)\n'
    text += '\t\t\t\t\t// original image\n'
    text += '\t\t\t\t\tconsole.log(e.detail.image)\n'
    text += '\t\t\t\t} catch(e) {\n'
    text += '\t\t\t\t\talert(e)\n'
    text += '\t\t\t\t}\n'
    text += '\t\t\t})\n'
    text += '\n'
    text += '\t\t\t//sample 2\n'
    text += '\t\t\tfunction saveCutout(id, name) {\n'
    text += '\t\t\t\tconst rbs = document.querySelectorAll("remove-background"); \n'
    text += '\t\t\t\tlet stopParentLoop = false;\n'
    text += '\t\t\t\tfor (const rb of rbs) {\n'
    text += '\t\t\t\t\tif (rb.getAttribute("image-data") === id) {\n'
    text += '\t\t\t\t\t\tconst shadowRoot = rb.shadowRoot;\n'
    text += '\t\t\t\t\t\tconst elementInShadow = shadowRoot.getElementById(id);\n'
    text += '\t\t\t\t\t\tconst childElements = elementInShadow.querySelectorAll(".cutout-data");\n'
    text += '\t\t\t\t\t\tfor (const child of childElements) {\n'
    text += '\t\t\t\t\t\t\tconst cutoutImageData = child.src\n'
    text += '\t\t\t\t\t\t\t// TODO\n'
    text += '\t\t\t\t\t\t\t// ------------------------------------\n'
    text += '\t\t\t\t\t\t\t// save cutoutImageData to your storage\n'
    text += '\t\t\t\t\t\t\tconsole.log(cutoutImageData)\n'
    text += '\t\t\t\t\t\t\t\n'
    text += '\t\t\t\t\t\t\t// ------------------------------------\n'
    text += '\t\t\t\t\t\t\tstopParentLoop = true;\n'
    text += '\t\t\t\t\t\t\tbreak;\n'
    text += '\t\t\t\t\t\t};\n'
    text += '\t\t\t\t\t}\n'
    text += '\t\t\t\t\tif (stopParentLoop) {\n'
    text += '\t\t\t\t\t\tbreak;\n'
    text += '\t\t\t\t\t}\n'
    text += '\t\t\t\t}\n'
    text += '\t\t\t}\n'
    text += '\t\t</script>\n'
    text += '\t</body>\n'
    text += '</html>\n'

    function download() {
        analytics.sendEventName('click', `${page}:download`)
        const data = new Blob([text], { type: 'text/plain' })
        const textFile = window.URL.createObjectURL(data)

        const a = document.createElement('a')
        a.target = '_blank'
        a.href = textFile
        a.download = "adobe-remove-background.html"
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
    }

    function open() {
        analytics.sendEventName('click', `${page}:open`)
        window.open(`${process.env.REACT_APP_DISDK_URL}/demo/remove-background/html/index.html`, '_blank')
    }

    return <div className={isMobile ? "adobe-app-sample-code" : "adobe-app-sample-code-side-by-side"}>
        <div className={isMobile ? "adobe-app-sample-code-child" : "adobe-app-sample-code-child-side-by-side" }>
            <Well>
                <span>HTML</span>
                <SyntaxHighlighter lineNumberStyle={lineNumberStyle} showLineNumbers={showLineNumbers} language={language} style={style}>
                    {text}
                </SyntaxHighlighter>
                <Button variant="cta" onClick={e => download(e)}>Download</Button>
                <Button variant="cta" onClick={e => open(e)}>Open HTML in New Tab</Button>
            </Well>
        </div>
        <div className={isMobile ? "adobe-app-sample-code-child" : "adobe-app-sample-code-child-side-by-side" }>
            <Well>
                <span>PREVIEW</span>
                <iframe title="int-html-demo" frameBorder="0" className='adobe-app-iframe' src={`${process.env.REACT_APP_DISDK_URL}/demo/remove-background/html/index.html`} />
            </Well>
        </div>
    </div>

}
